import React from 'react';
import strings from 'strings';

import { BannerMobile } from '../Banner';
import * as styles from './ReadyForEtrnBanner.scss';

const ReadyForEtrnBannerMobile = (props) => {
  const {
    readyForEtrnUrl,
    closeBanner,
    imageUrl,
  } = props;

  return (
    <BannerMobile
      url={readyForEtrnUrl}
      closeBanner={closeBanner}
      primaryText={strings.getBadgeEtrn}
      secondaryText={strings.standOutFromCompetition}
      buttonText={strings.getBadge}
      imageUrl={imageUrl}
      imageAlt="etrn-image"
      className={styles.readyForEtrnBanner}
      textInOneRow
    />
  );
};

export default ReadyForEtrnBannerMobile;
